module.exports = __webpack_public_path__ + "static/media/Voltorb_gaussian2.57e96616.png";